import { render, staticRenderFns } from "./DashboardChartsWithInfo.vue?vue&type=template&id=77f450f2&"
import script from "./DashboardChartsWithInfo.vue?vue&type=script&lang=js&"
export * from "./DashboardChartsWithInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\06.04\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77f450f2')) {
      api.createRecord('77f450f2', component.options)
    } else {
      api.reload('77f450f2', component.options)
    }
    module.hot.accept("./DashboardChartsWithInfo.vue?vue&type=template&id=77f450f2&", function () {
      api.rerender('77f450f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/ui/DashboardChartsWithInfo.vue"
export default component.exports